import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { runtimePoliciesQuery } from '../../services/api/runtime-policy.queries.js';

interface RuntimePolicyChipProps {
  policyId: number | null | undefined;
  className?: string;
}

/** Small chip naming the runtime policy something runs under: its name, or its id when the list could not be read. */
export const RuntimePolicyChip: React.FC<RuntimePolicyChipProps> = ({ policyId, className = '' }) => {
  const policies = useQuery(runtimePoliciesQuery());
  if (policyId == null) return null;
  const name = policies.isError
    ? `Policy #${policyId}`
    : (policies.data?.find((policy) => policy.id === policyId)?.name ?? null);
  if (!name) return null;
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full border bg-surface-alt px-2.5 py-0.5 text-[11px] font-medium text-muted ${className}`}
      title="Runtime policy serving this conversation"
    >
      {name}
    </span>
  );
};
